import updateLen from 'lib/updateLen'

let buildDict = (data, customCols, customCells) => {
	let dict = data.reduce((dict, item) => {
		dict.items[item.d] = dict.items[item.d] || {}
		dict.items[item.d][item.name] = item

		if(dict.names.indexOf(item.name) === -1) {
			dict.names.push(item.name)
		}

		dict.len[item.name] = dict.len[item.name] || {mass: [0, 0], thick: [0, 0]}
		dict.len[item.name] = {
			mass: updateLen(item.mass, dict.len[item.name].mass),
			thick: updateLen(item.thick, dict.len[item.name].thick)
		}
		dict.len['d'] = updateLen(item.d, dict.len['d'])

		return dict
	}, {names: [], items: {}, len: {d: [0, 0]}})

	customCols.forEach(col => {
		Object.keys(customCells[col]).forEach(d => {
			dict.len[col] = updateLen(customCells[col][d], dict.len[col] || [0, 0])
		})
	})

	return dict
}

export default buildDict


/** WEBPACK FOOTER **
 ** ./src/scripts/components/ComplexTable/buildDict.js
 **/